import React from 'react';
import { UserDeleteOutlined } from '@ant-design/icons';
import { Button, Flex, Select, SelectProps, Typography } from 'antd';
import { IUserData } from '@redux/types/types';
import { AssignedRole } from '@modules/Roles/types/roles';
import styles from './workspaceMember.module.scss';

interface IWorkspaceMemberProps {
  user: IUserData;
  workspaceName: string;
  isDisabled?: boolean;
  roleOptions?: SelectProps['options'];
  onRemove: (user: IUserData) => void;
  onRoleChange: (change: AssignedRole) => void;
}

const WorkspaceMember: React.FC<IWorkspaceMemberProps> = ({
  onRemove,
  onRoleChange,
  isDisabled = false,
  roleOptions,
  user,
  workspaceName,
}) => {
  const { email, fullName, workspaces } = user;
  const workspace = workspaces.find((ws) => ws.name === workspaceName);

  return (
    <Flex justify="space-between" align="center" className={styles.container}>
      <Typography.Paragraph>
        {fullName}
        <br />
        <small>{email}</small>
      </Typography.Paragraph>
      <Flex align="flex-start" justify="flex-end">
        <Select
          className={styles.select}
          options={roleOptions}
          defaultValue={workspace?.role_id}
          onChange={(roleId: string) => onRoleChange({ user, roleId })}
          disabled={isDisabled}
        />
        <Button
          type="link"
          size="small"
          danger
          icon={<UserDeleteOutlined />}
          onClick={() => onRemove(user)}
          disabled={isDisabled}
        />
      </Flex>
    </Flex>
  );
};

export default WorkspaceMember;
